// extracted by mini-css-extract-plugin
export default {"button_on_right":"DeleteSheet_button_on_right__tAqkM","container":"DeleteSheet_container__22D2O","content_height":"DeleteSheet_content_height__GnjBL"};